const GoldStockActionTypes = {
	/** ***************** GET GOLD STOCK REPORT START *********************** */
	GET_GOLD_STOCK_REPORT_START: 'get_gold_stock_report_start',
	GET_GOLD_STOCK_REPORT_SUCCESS: 'get_gold_stock_report_success',
	GET_GOLD_STOCK_REPORT_FAILURE: 'get_gold_stock_report_failure',
	GET_GOLD_STOCK_REPORT_RESPONSE_RESET: 'get_gold_stock_report_response_reset',
	GET_GOLD_STOCK_REPORT_RESPONSE_CHANGED: 'get_gold_stock_report_response_changed',
	/** ***************** GET GOLD STOCK REPORT END *********************** */
};

export default GoldStockActionTypes;
